import { z } from 'zod';

import { IsoDateTimeSchema, UuidSchema } from './common.js';

/**
 * "Where you're signed in" - the signed-in user's own live sessions, one per
 * device/browser, served by `/me/sessions`. Signing one out revokes it at
 * once: the next request from that device gets a 401 and lands on /login.
 */

export const UserSessionLocationSchema = z.object({
  city: z.string().nullable(),
  region: z.string().nullable(),
  /** ISO 3166-1 alpha-2, e.g. "IN". */
  country: z.string().nullable(),
});
export type UserSessionLocation = z.infer<typeof UserSessionLocationSchema>;

export const UserSessionSchema = z.object({
  id: UuidSchema,
  /** Raw User-Agent of the device's latest sign-in / token refresh. */
  userAgent: z.string().nullable(),
  ipAddress: z.string().nullable(),
  /** Coarse IP geolocation; null for private / unknown addresses. */
  location: UserSessionLocationSchema.nullable(),
  signedInAt: IsoDateTimeSchema,
  /** Latest token refresh - accurate to about one access-token lifetime. */
  lastActiveAt: IsoDateTimeSchema,
  /** The session making this request. */
  current: z.boolean(),
});
export type UserSession = z.infer<typeof UserSessionSchema>;

export const RevokeOtherSessionsResultSchema = z.object({
  revoked: z.number().int().nonnegative(),
});
export type RevokeOtherSessionsResult = z.infer<typeof RevokeOtherSessionsResultSchema>;
